import type { FC, PropsWithChildren } from "react";
import { AlertScope } from "./Alert";
import { AlertToasts } from "./AlertToasts";

export const AlertRootScope: FC<PropsWithChildren> = (props) => {
	return (
		<AlertScope>
			<AlertToasts />
			{props.children}
		</AlertScope>
	);
};
